import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	actionColumn,
	licenseColumn,
	numberBelongsToColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * Wrong Number on File (PD-16254) — active buyers whose number on file is held at the regulator by a different business (name and street number both differ). The matchmaker flags these (match_signals.numberCollision); the fix is a corrected number, reviewed in the matchmaker.
 */
export const wrongNumberList: ListBuilderList = {
	id: 'compliance-wrong-number',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'Wrong #',
	type: 'default',
	active: true,
	sortOrder: 5,
	filterRules: {
		...hideOtherCardFilters(['licenseNumberCollision']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseNumberCollision: {
			defaultValue: [
				{ id: 'yes', label: 'Number belongs to another business' },
			],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		numberBelongsToColumn,
		whyHereColumn,
		actionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
